// PORTUGUÊS

export default {
    values: {
      timespan_start: "Início",
      timespan_end: "Fim"
    }
}
